if (!customElements.get('store-selector')) {
  customElements.define(
    'store-selector',
    class StoreSelector extends window.BAO.CustomElement() {
      _apiKey = '3cae6e1c11234e8796ef0c6061ea138d'

      constructor () {
        super()

        if (!this.noChoiceMade) return

        window.BAO.utils
          .fetchJSON(
            `https://api.ipgeolocation.io/ipgeo?apiKey=${this._apiKey}&fields=country_code2,country_name`,
            {
              method: 'GET',
            },
          )
          .then(res => {
            this.setupCountrySwitcherModal(res.country_code2, res.country_name)
          })
      }

      setupListeners () {
        super.setupListeners()

        this.onConfirmClick = this.onConfirmClick.bind(this)

        if (this.els?.confirm.exists) {
          this.els.confirm.elements.forEach(selectEl => {
            this.listeners.add(selectEl, 'click', this.onConfirmClick)
          })
        }
      }

      onConfirmClick (event) {
        event.preventDefault()

        window.localStorage.setItem(this.storageName, 'true')

        this.setAttribute('aria-hidden', 'true')
        document.body.classList.remove('util-SiteOverflowed')
      }

      setupCountrySwitcherModal (countryCode, countryName) {
        const matchedCountry = this.els.popup.elements.filter(popupEl => {
          return popupEl.dataset.countryList.includes(countryCode.toLowerCase())
        })

        this.els.text.elements.forEach(textEl => {
          textEl.innerHTML = textEl.innerHTML.replace('[country]', countryName)
        })

        if (matchedCountry.length > 0) {
          matchedCountry[0].setAttribute('aria-hidden', 'false')

          this.setAttribute('aria-hidden', 'false')
          document.body.classList.add('util-SiteOverflowed')
        } else {
          window.localStorage.setItem(this.storageName, 'true')
        }
      }

      get noChoiceMade () {
        return (
          window.localStorage.getItem(this.storageName) == null &&
          !Shopify.designMode
        )
      }

      get storageName () {
        return `BAO-store-goodhood`
      }
    },
  )
}
